import { getAppShortName } from '@proton/shared/lib/apps/helper';
import { APPS, type APP_NAMES } from '@proton/shared/lib/constants';
import clsx from '@proton/utils/clsx';

import Logo from '../../components/logo/Logo';
import NewBadge from '../../components/newBadge/NewBadge';

const NEW_BADGE_APPS: APP_NAMES[] = [APPS.PROTONLUMO, APPS.PROTONMEET, APPS.PROTONSHEETS, APPS.PROTONAUTHENTICATOR];

interface ProductIconProps {
    appToLinkTo: APP_NAMES;
    current?: boolean;
    hideName?: boolean;
}

const ProductIcon = ({ appToLinkTo, current, hideName }: ProductIconProps) => {
    let appToLinkToName = getAppShortName(appToLinkTo);

    if (appToLinkTo === APPS.PROTONLUMO) {
        appToLinkToName = `${appToLinkToName} AI`;
    }

    if (appToLinkTo === APPS.PROTONAUTHENTICATOR) {
        appToLinkToName = 'Auth';
    }

    return (
        <>
            <div
                className="apps-dropdown-logo-wrapper relative flex items-center justify-center rounded-lg border border-weak w-custom h-custom mx-auto"
                style={{ '--w-custom': '3.25rem', '--h-custom': '3.25rem' }}
            >
                <Logo appName={appToLinkTo} variant="glyph-only" className="shrink-0" size={9} />
                {NEW_BADGE_APPS.includes(appToLinkTo) ? (
                    <span className="apps-dropdown-new-badge absolute">
                        <NewBadge />
                    </span>
                ) : null}
            </div>
            {!hideName && (
                <span
                    className={clsx(
                        'block text-center text-sm mt-1 apps-dropdown-app-name',
                        current ? 'color-norm text-semibold' : 'color-weak'
                    )}
                    aria-hidden
                >
                    {appToLinkToName}
                </span>
            )}
        </>
    );
};

export default ProductIcon;
